import { PositionNames } from "../Api"

export const ALL_STAR_TICKET_LINK = `https://premierlacrosseleague.com/kansas-city?source=All_Star_Voting_Page`

export const ALL_STAR_TEAM_RULES: { [key: string]: number } = {
  A: 2,
  M: 2,
  D: 2,
  FO: 1,
  G: 1,
}

export const ALL_STAR_POSITION_ORDER: { [key: string]: number } = {
  A: 1,
  M: 2,
  D: 3,
  FO: 4,
  G: 5,
}

export const ASG_POSITION_TABS: PositionNames[] = ['Attack', 'Midfield', 'Defense', 'Faceoff', 'Goalie']
